(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-groups"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
  const productGroupTriggers = document.querySelectorAll('[data-product-group-trigger]');

  if (!productGroupTriggers.length) return;

  const mobileQuery = window.matchMedia('(max-width: 749px)');

  productGroupTriggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const item = trigger.closest('.product-group__item');
      const productForm = item?.querySelector('[data-product-group-form]');

      if (!item || !productForm) return;

      if (mobileQuery.matches) {
        item.classList.toggle('product-group__open');
        return;
      }

      const form = productForm.querySelector('form');

      if (form) {
        form.requestSubmit();
      }
    });
  });

  document.addEventListener('click', (event) => {
    if (!mobileQuery.matches) return;

    const group = event.target.closest('.product-group__item');

    if (group) return;

    document
      .querySelectorAll('.product-group__item.product-group__open')
      .forEach((item) => {
        item.classList.remove('product-group__open');
      });
  });
});
  } catch(e) { console.error(e); }
})();

})();
